/**
 * Updates the page favicon and title dynamically.
 * Used for partner-specific branding when partners use path-based routing.
 */
export const updatePageBranding = (options: {
  favicon?: string;
  title?: string;
}) => {
  // Update favicon
  if (options.favicon) {
    // Remove existing favicon links
    const existingFavicons = document.querySelectorAll(
      'link[rel="icon"], link[rel="shortcut icon"]'
    );
    existingFavicons.forEach((link) => link.remove());

    // Add new favicon
    const faviconLink = document.createElement('link');
    faviconLink.rel = 'icon';
    faviconLink.href = options.favicon;
    document.head.appendChild(faviconLink);
  }

  // Update page title
  if (options.title) {
    document.title = options.title;
  }
};
